<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded01">
<p class="dedicationText"><em class="italic">In dedicating books I have too long overlooked someone who deserves a dedication more than almost anyone—my agent, Richard Curtis. He not only makes my job more profitable, he also makes it much more fun. One day his Collected Correspondence will be the humorous bestseller of the twenty-first century. So, thanks, Richard! This one is for you. (Have you sold the Swahili rights yet?)</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// futureindefinite_ded01.vue?bee05402